import { useEffect, useRef } from 'react';

export function useCursor() {
  const curRef  = useRef(null);
  const curRRef = useRef(null);

  useEffect(() => {
    let mx = 0, my = 0, rx = 0, ry = 0, raf;

    const onMove = (e) => {
      mx = e.clientX;
      my = e.clientY;
      if (curRef.current) {
        curRef.current.style.left = mx + 'px';
        curRef.current.style.top  = my + 'px';
      }
    };

    const loop = () => {
      rx += (mx - rx) * 0.14;
      ry += (my - ry) * 0.14;
      if (curRRef.current) {
        curRRef.current.style.left = rx + 'px';
        curRRef.current.style.top  = ry + 'px';
      }
      raf = requestAnimationFrame(loop);
    };

    document.addEventListener('mousemove', onMove);
    raf = requestAnimationFrame(loop);

    const grow = () => {
      if (!curRRef.current) return;
      curRRef.current.style.width   = '52px';
      curRRef.current.style.height  = '52px';
      curRRef.current.style.opacity = '0.6';
    };
    const shrink = () => {
      if (!curRRef.current) return;
      curRRef.current.style.width   = '32px';
      curRRef.current.style.height  = '32px';
      curRRef.current.style.opacity = '1';
    };

    const attachHover = () => {
      document.querySelectorAll('a, button, input, .exp-head').forEach((el) => {
        el.addEventListener('mouseenter', grow);
        el.addEventListener('mouseleave', shrink);
      });
    };

    // Run after first paint so elements exist
    const timer = setTimeout(attachHover, 500);

    return () => {
      document.removeEventListener('mousemove', onMove);
      cancelAnimationFrame(raf);
      clearTimeout(timer);
    };
  }, []);

  return { curRef, curRRef };
}
